<div class="svg-container">
	<svg class="svg-logo" [style.max-height]="height + ' !important'" viewBox="-0.952 0.317 49.972 49.969" xmlns="http://www.w3.org/2000/svg">
		<g id="servicios_gt-logo-140x51px-white" clip-path="url(#clip-servicios_gt-logo-140x51px-white)">
			<g id="Group_26" data-name="Group 26" transform="translate(-238 -143.126)">
				<g id="servicios_gt_isotipo" transform="translate(238 152.126)">
					<path id="head-svg" data-name="Path 34"
						d="M 19.232,0.87782553 A 5.3611745,5.3611745 0 1 1 13.870826,6.239 5.3611745,5.3611745 0 0 1 19.232,0.87782553 Z"
						style="stroke-width:0.8593;paint-order:fill"
						fill="currentColor" class="svg-part"/>
					<path id="body-svg" data-name="Path 35"
						d="m 396.555,2929.572 c 0,0 2.589,-0.983 4.41,0.529 1.821,1.512 2.111,1.55 6.018,4.965 3.907,3.415 6.183,3.016 9.342,1.123 -2.547,2.443 -9.224,9.038 -10.749,10.628 a 2.78,2.78 0 0 1 -3.472,0.307 c 0,0 -14.067,-11.957 -14.7,-12.539 -0.633,-0.582 -1.457,-1.655 0.406,-2.333 1.863,-0.678 8.745,-2.68 8.745,-2.68 z"
						transform="translate(-386.662,-2914.118)" style="paint-order:fill" 
						fill="currentColor" class="svg-part" />
					<path id="arm-svg" data-name="Path 36"
						d="m 21.510607,16.556189 c 5.50762,5.808849 8.491147,3.05464 10.316899,1.528518 0.407499,-0.430669 13.413887,-13.243696 13.413887,-13.243696 0,0 -1.383097,-3.171296 -6.429685,0.3835278 C 32.66967,9.1620915 25.546439,13.935415 21.510607,16.556189 Z"
						style="stroke-width:0.799016;paint-order:fill" 
						fill="currentColor" class="svg-part" />
				</g>
			</g>
		</g>
	</svg>
</div>